// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3gxjv","header":"MergedInvoice_header__tiMiD"};